/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'ai-mate.agent-header-banner-label': '支持人员横幅',
  'ai-mate.agent-list.all-agents-section-title': '所有支持人员',
  'ai-mate.agent-list.beta-lozenge-title': '测试版',
  'ai-mate.agent-list.change-owner-success-flag-description': '您已将 "{agentName}" 的负责人更改为 "{newOwnerName}"',
  'ai-mate.agent-list.change-owner-success-flag-title': '负责人已成功更改',
  'ai-mate.agent-list.delete-agent-confirm-body': '确定要删除此支持人员吗？此操作无法撤消。',
  'ai-mate.agent-list.delete-agent-confirm-title': '是否删除 "{agentName}"？',
  'ai-mate.agent-list.delete-agent-error': '无法删除支持人员',
  'ai-mate.agent-list.delete-agent-error-flag-description': '删除支持人员时出错。请稍后重试。',
  'ai-mate.agent-list.delete-agent-error-flag-title': '无法删除支持人员',
  'ai-mate.agent-list.delete-agent-error.agent-in-use': '支持人员当前正在使用中。请稍后重试。',
  'ai-mate.agent-list.delete-agent-error.agent-not-found': '未找到该支持人员。',
  'ai-mate.agent-list.delete-agent-error.incorrect-owner': '无法删除非由您自己创建的支持人员。请联系支持人员负责人。',
  'ai-mate.agent-list.delete-agent-success-flag-description': '您已删除 {agentName}',
  'ai-mate.agent-list.delete-agent-success-flag-title': '支持人员已删除',
  'ai-mate.agent-list.development-section-title': '开发支持人员',
  'ai-mate.agent-list.recommended-agents-section-title': '推荐',
  'ai-mate.agent-list.templates-description':
    '使用这些模板创建您自己的开发支持人员。为您的工作选择合适的支持人员模板，选择“使用模板”，然后在模板提示中填写存储库、文件夹、语言和库等具体详细信息。创建定制的开发支持人员，为不同任务、项目或存储库进行编码。',
  'ai-mate.agent-list.templates-lozenge-title': '模板',
  'ai-mate.agent-list.templates-title': '对模板进行编码',
  'ai-mate.agent-message.agent-not-found': '未找到支持人员',
  'ai-mate.agent-message.convo-title': '已通过智能链接嵌入触发与 {agentName} 的聊天',
  'ai-mate.agent-message.copy-link': '复制支持人员链接',
  'ai-mate.agent-message.prompt': '提示',
  'ai-mate.agent-message.prompt-placeholder': '输入要发送给 "{agentName}" 的消息',
  'ai-mate.agent-message.prompt-submit': '提交',
  'ai-mate.agent-message.view-profile': '查看个人资料',
  'ai-mate.agent-modal.agent-delete-confirm.cancel-text': '取消',
  'ai-mate.agent-modal.agent-delete-confirm.confirm-text': '删除',
  'ai-mate.agent-picker.dropdown-item.non-default-agent-prefix': '支持人员 · {description}',
  'ai-mate.agent-profile-info.chat-with-agent': '与 {agentName} 聊天',
  'ai-mate.agent-profile-info.hidden-icon': '隐藏',
  'ai-mate.agent-profile-info.hidden-tooltip': '支持人员不会显示在搜索结果中',
  'ai-mate.agent-profile-info.star-agent-tooltip': '为支持人员加星',
  'ai-mate.agent-selector.default-agent-description': '获取解答、产生新想法和加快日常工作。',
  'ai-mate.agent-selector.default-agent-name': '聊天',
  'ai-mate.profile-card-preview.actions-title': '操作',
  'ai-mate.profile-card-preview.agent-default-title': '支持人员',
  'ai-mate.profile-card-preview.agent-description-label': '描述',
  'ai-mate.profile-card-preview.agent-title-label': '标题',
  'ai-mate.profile-card-preview.conversation-starters-heading': '对话开场白',
  'ai-mate.profile-card-preview.empty-actions': '无',
  'ai-mate.profile-card-preview.empty-conversation-starters': '无',
  'ai-mate.profile-card-preview.empty-instructions': '无',
  'ai-mate.profile-card-preview.empty-knowledge-scope': '未选择',
  'ai-mate.profile-card-preview.instructions-title': '说明',
  'ai-mate.profile-card-preview.knowledge-title': '知识',
  'ai-mate.profile-card-preview.regenerate-label': '重新生成 "{fieldName}"',
  'conversation-assistant-agent.create-agent.agent-name-copy': '{agentName} - 副本',
  'conversation-assistant-agent.create-agent.conversation-starters.drag-handle-label': '拖动以重新排序',
  'conversation-assistant-agent.create-agent.conversation-starters.form-error': '无法保存更改',
  'conversation-assistant-agent.create-agent.conversation-starters.form-generic-error': '发生未知错误。请重试',
  'conversation-assistant-agent.create-agent.conversation-starters.form-name-exists-error': '已存在同名支持人员',
  'conversation-assistant-agent.create-agent.conversation-starters.remove-label': '移除',
  'conversation-assistant-agent.create-agent.generate-conversation-starters-button-text': '生成对话开场白',
  'conversation-assistant-agent.create-agent.input-max-length-error-message':
    '{maxLength, plural, other {{fieldName} 不得超过 {maxLength,number} 个字符}}',
  'conversation-assistant-agent.create-agent.next-step-button-label': '下一步',
  'conversation-assistant-agent.create-agent.restart-creation-button-label': '重新启动',
  'conversation-assistant-agent.create-agent.skip-to-manual-setup-button-label': '跳至手动设置',
  'create-agent.owner-field.confirm-modal-cancel': '取消',
  'create-agent.owner-field.confirm-modal-confirm': '是的，继续',
  'create-agent.owner-field.confirm-modal-content':
    '您即将将此支持人员的负责人更改为 {name}。执行此操作后，您将无法再编辑或管理此支持人员。',
  'create-agent.owner-field.confirm-modal-title': '您即将失去编辑权限',
  'create-agent.owner-field.owner-description': '此人可以编辑或管理支持人员。',
  'create-agent.owner-field.owner-label': '负责人',
  'rovo-chat.agent-card.deactivated-name': '{name}（已停用）',
  'rovo-chat.browse-agents.agents-error-rate-limited-message': '请求过多。请稍候。',
  'rovo-chat.browse-agents.agents-error-try-again-button': '重试',
  'rovo-chat.browse-agents.all-agents-button': '全部',
  'rovo-chat.browse-agents.close-button': '关闭',
  'rovo-chat.browse-agents.create-agent-button': '创建',
  'rovo-chat.browse-agents.create-an-agent-button': '创建支持人员',
  'rovo-chat.browse-agents.created-by-label': '<text>创建者：</text>{creatorName}',
  'rovo-chat.browse-agents.development-button': '编码支持人员',
  'rovo-chat.browse-agents.favorite-agents-button': '收藏项',
  'rovo-chat.browse-agents.favourited-agent-label': '已收藏的支持人员',
  'rovo-chat.browse-agents.learn-more': '了解更多',
  'rovo-chat.browse-agents.modal-title': '浏览支持人员',
  'rovo-chat.browse-agents.my-agents-button': '我的支持人员',
  'rovo-chat.browse-agents.no-created-agents':
    '您似乎尚未创建任何支持人员。可以从复制其他现有支持人员开始，或者从头开始创建一个。',
  'rovo-chat.browse-agents.no-created-agents-header': '尚未创建任何支持人员',
  'rovo-chat.browse-agents.no-results': '无结果',
  'rovo-chat.browse-agents.no-starred-agents': '如果您有最喜欢的或经常使用的支持人员，请为其加星以便于访问。',
  'rovo-chat.browse-agents.no-starred-agents-header': '您尚未为任何支持人员加星',
  'rovo-chat.browse-agents.search-input.placeholder': '搜索支持人员',
  'rovo-chat.browse-agents.search-templates-input.placeholder': '搜索模板',
  'rovo-chat.browse-agents.see-all-agents-button': '查看所有支持人员',
  'rovo-chat.browse-agents.starred-agents-button': '已加星',
  'rovo-chat.browse-agents.templates-button': '模板',
  'rovo-chat.create-agent.actions-section-description':
    '为您的支持人员添加操作，以在 Jira、Confluence 和 Jira Service Management 中执行任务。<link>什么是支持人员操作？</link>',
  'rovo-chat.create-agent.add-actions-button-label': '添加操作',
  'rovo-chat.create-agent.all-content-label': '所有内容',
  'rovo-chat.create-agent.back-button': '返回',
  'rovo-chat.create-agent.confirm-leave-modal.body': '您还未创建支持人员，要放弃吗？',
  'rovo-chat.create-agent.confirm-leave-modal.cancel-button': '取消',
  'rovo-chat.create-agent.confirm-leave-modal.confirm-button': '是，放弃支持人员',
  'rovo-chat.create-agent.confirm-leave-modal.title': '未完成创建的支持人员',
  'rovo-chat.create-agent.confirm-restart-modal.body': '确定要放弃对此支持人员所做的更改吗？',
  'rovo-chat.create-agent.confirm-restart-modal.confirm-button': '确认',
  'rovo-chat.create-agent.confirm-restart-modal.title': '重新开始创建',
  'rovo-chat.create-agent.confluence-checkbox-label': 'Confluence',
  'rovo-chat.create-agent.conversation-starters-field-description':
    '用户可以使用这些开场白来开始与您的支持人员聊天。如果您想不到如何开场，我们可以为您生成。',
  'rovo-chat.create-agent.conversation-starters-field-label': '对话开场白',
  'rovo-chat.create-agent.create-agent-button': '创建',
  'rovo-chat.create-agent.ctions-section-title': '操作',
  'rovo-chat.create-agent.description-field-description': '用户可使用支持人员个人资料中的描述来了解有关它的更多信息。',
  'rovo-chat.create-agent.description-field-label': '描述',
  'rovo-chat.create-agent.description-field-placeholder': '撰写有关您支持人员的简短描述（例如，营销博文的创意作者）',
  'rovo-chat.create-agent.instructions-field-description':
    '您希望此支持人员有何行为？它能做些什么？<link>有关为支持人员编写说明的更多信息</link>',
  'rovo-chat.create-agent.instructions-field-label': '说明',
  'rovo-chat.create-agent.instructions-field-placeholder': '为此支持人员自定义说明',
  'rovo-chat.create-agent.intro-description-part-1':
    '创建具有专业知识的支持人员来回答问题、撰写和审查内容，以及执行任务，以帮助您推进工作。',
  'rovo-chat.create-agent.intro-description-part-2': '如果您不需要帮助，可以直接<bold>跳至手动设置</bold>。',
  'rovo-chat.create-agent.intro-description-part-3': '如果您需要帮助，请留在这里，我们可以一起构建一个支持人员。',
  'rovo-chat.create-agent.intro-step-1-content':
    '我会根据您写的内容为支持人员创建指令。只需告诉我您计划将支持人员用于何种用途即可。',
  'rovo-chat.create-agent.intro-step-1-title': '描述您想让支持人员处理哪些任务',
  'rovo-chat.create-agent.intro-step-2-content':
    '我们可以共同商讨您支持人员的名称和个性特征。请说明您支持人员的特点：善解人意、坦率直白还是幽默风趣？',
  'rovo-chat.create-agent.intro-step-2-title': '加入一些个性化元素',
  'rovo-chat.create-agent.intro-step-3-content':
    '点击<bold>下一步</bold>以查看您的新支持人员，添加操作、知识和个人资料照片。完成所有操作后，选择<bold>创建</bold>。',
  'rovo-chat.create-agent.intro-step-3-title': '查看并创建您的支持人员',
  'rovo-chat.create-agent.intro-title': '👋 让我们来创建您的支持人员吧',
  'rovo-chat.create-agent.jira-checkbox-label': 'Jira',
  'rovo-chat.create-agent.jira-filter-placeholder': '所有项目',
  'rovo-chat.create-agent.knowledge-field-description': '仅允许支持人员引用您提供的来源，以此限定支持人员的知识范围',
  'rovo-chat.create-agent.knowledge-field-label': '知识',
  'rovo-chat.create-agent.knowledge-scope-checkbox-label': '仅引用这些来源',
  'rovo-chat.create-agent.knowledge-select.suggestion-label': '建议',
  'rovo-chat.create-agent.manage-actions-button-label': '管理操作',
  'rovo-chat.create-agent.name-field-description': '用户可使用此名称来查找支持人员。',
  'rovo-chat.create-agent.name-field-label': '名称',
  'rovo-chat.create-agent.name-field-placeholder': '为您的支持人员命名',
  'rovo-chat.create-agent.natural-language-form-creator.generic-error': '出现意外错误。请重试。',
  'rovo-chat.create-agent.natural-language-form-creator.static-first-message':
    '您好！我可以帮您构建自定义支持人员。请告诉我您希望支持人员完成哪些任务？',
  'rovo-chat.create-agent.nl-input-field.placeholder': '输入消息',
  'rovo-chat.create-agent.nl-input-field.send-button-label': '发送',
  'rovo-chat.create-agent.page-title': '创建支持人员',
  'rovo-chat.create-agent.page-title-edit': '编辑支持人员',
  'rovo-chat.create-agent.search-for-pages-placeholder': '搜索页面',
  'rovo-chat.create-agent.search-for-spaces-placeholder': '搜索空间',
  'rovo-chat.create-agent.select-action-modal-all-tab-title': '全部',
  'rovo-chat.create-agent.select-action-modal-beta-tag': '测试版',
  'rovo-chat.create-agent.select-action-modal-cancel-button': '取消',
  'rovo-chat.create-agent.select-action-modal-close-icon-tooltip': '关闭',
  'rovo-chat.create-agent.select-action-modal-confluence-tab-title': 'Confluence',
  'rovo-chat.create-agent.select-action-modal-jira-tab-title': 'Jira',
  'rovo-chat.create-agent.select-action-modal-many-actions-added-warning':
    '{count, plural, other {选择 {count,number} 项以下的操作可获得最佳性能}}',
  'rovo-chat.create-agent.select-action-modal-save-button': '保存',
  'rovo-chat.create-agent.select-action-modal-search-input-placeholder': '搜索操作',
  'rovo-chat.create-agent.select-action-modal-title': '添加操作',
  'rovo-chat.create-agent.select-content-under-label': '选择此项下方的内容',
  'rovo-chat.create-agent.select-spaces-label': '选择空间',
  'rovo-chat.create-agent.selected-actions-label': '所选操作：',
  'rovo-chat.create-agent.unknown-owner': '未知',
  'rovo-chat.create-agent.update-agent-button': '更新',
  'rovo-chat.edit-agent.confirm-discard-modal.body': '如果继续，您会丢失未保存的更改。选择“取消”可继续编辑此支持人员。',
  'rovo-chat.edit-agent.confirm-discard-modal.confirm-button': '继续，放弃更改',
  'rovo-chat.edit-agent.confirm-discard-modal.title': '放弃更改',
  'rovo-chat.view-agent.about-label': '关于',
  'rovo-chat.view-agent.actions-label': '操作',
  'rovo-chat.view-agent.beta-label': '测试版',
  'rovo-chat.view-agent.chat-to-agent-button': '与支持人员聊天',
  'rovo-chat.view-agent.close-button': '关闭',
  'rovo-chat.view-agent.copy-instructions-label': '复制',
  'rovo-chat.view-agent.copy-instructions-tooltip': '复制指令',
  'rovo-chat.view-agent.created-by-label': '<text>创建者：</text>{agentName}',
  'rovo-chat.view-agent.favourites-metadata-label': '收藏夹数量',
  'rovo-chat.view-agent.go-back-label': '返回',
  'rovo-chat.view-agent.hidden-instructions-description': '为保护隐私，使用代码构建的 Forge 支持人员会隐藏其指令。',
  'rovo-chat.view-agent.hidden-instructions-title': '这些是私密指令',
  'rovo-chat.view-agent.hidden-knowledge-description': '使用代码构建的 Forge 支持人员不使用典型的知识来源',
  'rovo-chat.view-agent.instructions-label': '说明',
  'rovo-chat.view-agent.knowledge-label': '知识',
  'rovo-chat.view-agent.member-count': '{count, plural, other {{count,number} 个成员}}',
  'rovo-chat.view-agent.modal-title': '浏览支持人员',
  'rovo-chat.view-agent.no-actions': '无操作',
  'rovo-chat.view-agent.no-instruction-placeholder': '此支持人员没有自定义说明',
  'rovo-chat.view-agent.no-knowledge-added': '无自定义知识来源',
  'rovo-chat.view-agent.no-teams': '不属于任何团队',
  'rovo-chat.view-agent.open-chat-label': '打开聊天',
  'rovo-chat.view-agent.reactions-metadata-label': '回应数量',
  'rovo-chat.view-agent.rovo-agent-label': 'Rovo 支持人员',
  'rovo-chat.view-agent.teams-label': '团队',
  'rovo-chat.view-agent.users-metadata-label': '用户数量',
};
